import { createAction } from '@reduxjs/toolkit';

/**
 * Used internally to signals a successful request.
 * Do not dispatch it directly.
 */
export const promoCodeQueryPrams = createAction<
  { promoCode: string },
  'api/ADD_BONUS_CODE_QUERY_PRAMS'
>('api/ADD_BONUS_CODE_QUERY_PRAMS');
